import { render, staticRenderFns } from "./MarcarBloco.vue?vue&type=template&id=99ef0d5c&"
import script from "./MarcarBloco.vue?vue&type=script&lang=js&"
export * from "./MarcarBloco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports